// components/ChatInput.jsx
import React from 'react';
import { IoSend } from 'react-icons/io5';

export const ChatInput = ({ value, onChange, onSubmit, disabled, widgetDetails, placeholder = 'Type your message...' }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (value.trim().length > 0) {
      onSubmit(e);
    }
  };

  return (
    <form
      className='chatbox-group d-flex justify-content-between align-items-center position-relative'
      onSubmit={handleSubmit}
      style={{ border: `1.5px solid ${widgetDetails?.chat_input_bgcolor}` }}
    >
      <input
        type='text'
        className='form-control chat-input'
        placeholder={placeholder}
        name='message'
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={{
          color: widgetDetails?.chat_input_font_color,
          fontSize: `${widgetDetails?.chat_input_fontsize}px`,
        }}
        autoComplete='off'
      />

      <style>
        {` 
          .chatbox-group input::placeholder { 
            color: ${widgetDetails?.chat_input_font_color}; 
            font-size: ${widgetDetails?.chat_input_fontsize}px;
          }
        `}
      </style>

      <div className='chatbox-input-group'>
        <button type='submit' className='btn send-btn' disabled={disabled || !value.trim()} style={{ backgroundColor: widgetDetails?.chat_input_bgcolor }}>
          <IoSend className='icon-send ms-1' style={{ color: widgetDetails?.chat_input_icon_color }} />
        </button>
      </div>
    </form>
  );
};
